import {createStickerSVG} from './TEMPLATE'

export const AvatarAlien = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'm30.7465,53.6689c.4295.4051,2.3337,2.11,5.1016,1.9273,2.2456-.1483,3.7515-1.4526,4.2513-1.9273',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'm22.5696,42.348c1.9926,3.7,5.3442,5.7121,7.4861,4.4943,2.1418-1.2178,2.2628-5.2045.2702-8.9045s-5.3442-5.7121-7.4861-4.4943-2.2628,5.2046-.2702,8.9045Z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'm35.9426,63c-8.125,0-11.9655-7.7752-13.12-10.6909-.2705-.6831-.6645-1.3029-1.1743-1.8319-1.8804-1.9513-6.49-7.7864-6.49-18.0994,0-14.9608,10.3921-22.3778,20.7843-22.3778s20.7843,7.417,20.7843,22.3778c0,10.3722-4.1733,15.6905-6.2294,17.8189-.6696.6932-1.2358,1.4796-1.6556,2.3472-4.0276,8.3235-8.733,10.4561-12.8993,10.4561Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'm49.0317,42.348c-1.9926,3.7-5.3442,5.7121-7.4861,4.4943-2.1418-1.2178-2.2628-5.2045-.2702-8.9045s5.3442-5.7121,7.4861-4.4943c2.1418,1.2179,2.2628,5.2046.2702,8.9045Z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarApple = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M35.046 20.733 L35.046 15.272 L30.702 10.929',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M57.3335,25.7657c3.6482,4.9493,4.3968,13.296,1.4093,21.1329-3.8569,10.1286-12.4875,15.573-19.2735,12.1633a10.24,10.24,0,0,1-1.3942-.849,3.7126,3.7126,0,0,0-4.3311-.0009,10.27,10.27,0,0,1-1.396.85c-6.7971,3.41-15.4276-2.0347-19.2846-12.1633-3.8569-10.1174-1.4756-21.0845,5.31-24.4942a10.42,10.42,0,0,1,9.838.4919s.0559.0336.1677.09a16.8628,16.8628,0,0,0,7.0878,1.9564,13.2712,13.2712,0,0,0,2.2487-.2145,18.6342,18.6342,0,0,0,2.126-.4632',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M48.0445,17.3947c3.9562,1.3292,6.8444,5.8193,6.8444,5.8193s-5.0135,1.8354-8.97.5062c-3.9508-1.3274-6.8444-5.8193-6.8444-5.8193S44.0937,16.0673,48.0445,17.3947Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
})

export const AvatarArc = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M13 36a23 23 0 1 0 46 0a23 23 0 1 0 -46 0Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M45.8149,44.9293 c-2.8995,1.6362-6.2482,2.5699-9.8149,2.5699s-6.9153-0.9336-9.8149-2.5699',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31',
      fill: true,
      stroke: false,
    },
    {
      path: 'M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31',
      fill: true,
      stroke: false,
    },
  ],
})

export const AvatarAtom = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M18.4119,36 c-6.1591-4.7995-9.4596-9.5293-8.0767-12.4346c1.569-3.3004,8.6926-3.405,17.792-0.8019',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M54.5651,36 c6.1592,4.7995,9.4596,9.5293,8.0766,12.4346c-1.5688,3.3004-8.6926,3.405-17.8035,0.8019 c-2.638-0.7554-5.4504-1.7432-8.344-2.9518c-1.3363-0.5462-2.6844-1.1388-4.0441-1.7896 c-1.8013-0.8599-3.5329-1.7548-5.1713-2.6728',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M44.0918,53c-1.6996,7.2511-4.4743,11.9598-7.6092,11.9598c-3.6489,0-6.8098-6.38-8.3555-15.7233l-0.4842-2.3455',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M28.9271,18.7895c1.7085-7.1316,4.4512-11.7492,7.5555-11.7492c3.6492,0,6.7985,6.38,8.3556,15.7233',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M28.1271,22.7636 c2.6496,0.7554,5.4619,1.7432,8.3671,2.9518',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M44.8382,49.2364 c-2.638-0.7554-5.4504-1.7432-8.344-2.9518c-1.3363-0.5462-2.6844-1.1388-4.0441-1.7896 c-1.8013-0.8599-3.5329-1.7548-5.1713-2.6728',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M45.8683,34.3501c0.0105,0.5455,0.0159,1.0955,0.0159,1.6499c0,1.9989-0.0698,3.9512-0.1976,5.8338 c-0.0533,0.8571-0.1204,1.7004-0.2004,2.528',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M23.7183,50.3166c-6.9369,1.3942-12.078,0.8539-13.3832-1.882c-1.1056-2.3228,0.7824-5.8117,4.7314-9.5702',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M27.1335,41.7408 C23.8451,39.8939,20.8971,37.947,18.4119,36',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M27.2788,41.8222 c-0.0485-0.0271-0.097-0.0543-0.1453-0.0814',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M44.8382,22.7636c0.1379,0.803,0.263,1.63,0.3744,2.4777',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M49.1309,21.7063c6.9986-1.4263,12.1984-0.9018,13.5108,1.8591c1.0638,2.2348-0.6435,5.5491-4.2915,9.1443',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M54.5651,36c-2.5217-1.964-5.52-3.9396-8.8785-5.8222',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M45.6866,30.1778 c3.3585,1.8826,6.3568,3.8582,8.8785,5.8222',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M41.666,43.947c-0.2817,0.1403-0.5677,0.2787-0.8578,0.4148',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M36.4942,25.7154 c1.325,0.5578,2.6729,1.1505,4.0325,1.8013c1.8013,0.8483,3.5212,1.7432,5.1598,2.6612',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M27.0903,36.7225c-0.0061-0.5548-0.0092-1.1129-0.0092-1.6746c0-2.6514,0.0697-5.2563,0.1976-7.7526',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M36.4942,46.2846 c-1.3363-0.5462-2.6844-1.1388-4.0441-1.7896c-1.8013-0.8599-3.5329-1.7548-5.1713-2.6728',
      fill: false,
      stroke: true,
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M33.5637 36.3268a3.2625 3.2625 0 1 0 6.525 0a3.2625 3.2625 0 1 0 -6.525 0Z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'M31.61,48.3635c0,0,0.3376-0.0601,0.9707-0.3281',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M49.7017,39.9667c0,0,1.4042-0.8972,1.6463-1.1023',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M31.7066,27.2953c-0.2829,0.143-0.5659,0.2907-0.8485,0.4432',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M22.2214,32.7675c0,0,0.2273-0.2384,0.8141-0.5891',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M39.7525,23.2019c0,0,1.6145-0.5904,1.9449-0.6609',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarCelebrate = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M50.6626 45.6395 L50.8308 45.8076 L28.9606 55.1086 L7.0904 64.4096 L16.3914 42.5394 L25.6923 20.6692',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M25.801 20.7779 L38.2616 33.2384 L50.6626 45.6395',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M25.6923 20.6692L25.801 20.7779',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M46.4905,7.3671c0.2347,0.4487,0.4027,0.943,0.4897,1.473c0.451,2.7473-1.447,5.4141-4.2392,5.9565',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M42.9327,14.7763c-0.5049,0.0384-1.0133,0.1573-1.509,0.364c-2.5697,1.0713-3.828,4.093-2.8105,6.7492',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M61.7928,26.7168c-0.0987,0.4967-0.2778,0.987-0.5425,1.4544c-1.372,2.4225-4.5229,3.309-7.0378,1.98',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M54.3745,30.2558c-0.4173-0.2868-0.8878-0.513-1.4036-0.663c-2.6733-0.7775-5.5486,0.7867-6.4223,3.4936',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarExplosion = createStickerSVG({
  strokeWidth: 3.5,
  paths: [
    {
      path: 'M30.5555,63.641c-0.0571,0-0.1148-0.0049-0.1729-0.0147c-0.4521-0.0791-0.7924-0.456-0.8252-0.914 l-1.0791-15.1065c-0.039-0.5508,0.3755-1.0293,0.9263-1.0684c0.5615-0.0322,1.0298,0.376,1.0689,0.9258l0.7934,11.1075 l6.2808-14.1553c0.1504-0.3389,0.4756-0.5674,0.8457-0.5928c0.372-0.0215,0.7236,0.1563,0.9184,0.4717l6.0591,9.7803 L44.428,43.0169c-0.0424-0.5019,0.2955-0.958,0.7886-1.0634l12.3501-2.627l-13.9126-3.3867 c-0.3823-0.0928-0.6743-0.4014-0.7466-0.7871c-0.0722-0.3867,0.0884-0.7793,0.4107-1.0049l7.4394-5.1904l-9.5825,2.3193 c-0.3374,0.083-0.6885-0.0166-0.935-0.2568c-0.2461-0.2412-0.3511-0.5928-0.2769-0.9297l3.0767-14.0156l-7.3111,11.206 c-0.3012,0.4629-0.9214,0.5918-1.3838,0.292c-0.4624-0.3018-0.5927-0.9219-0.291-1.3838l10.2969-15.7842 c0.2637-0.4052,0.7798-0.5625,1.2241-0.3759c0.4453,0.1865,0.6934,0.665,0.5899,1.1367l-3.9053,17.791l13.1968-3.1934 c0.4638-0.1172,0.9497,0.1221,1.1469,0.5606c0.1978,0.4385,0.0552,0.956-0.3393,1.2314l-9.9844,6.9658l16.021,3.8995 c0.4536,0.1103,0.7705,0.5195,0.7637,0.9863c-0.0069,0.4668-0.3355,0.8662-0.792,0.9639l-15.7764,3.3564l1.2232,14.3438 c0.039,0.4609-0.2432,0.8886-0.6822,1.0341c-0.4389,0.1446-0.9204-0.0293-1.1645-0.4228l-7.2642-11.7256l-7.1391,16.0898 C31.3065,63.4124,30.9451,63.641,30.5555,63.641z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M16.6297,48.5345c-0.3403,0-0.667-0.1738-0.853-0.4775c-0.251-0.4092-0.1753-0.9385,0.1792-1.2617 l7.8657-7.1602L10.4613,35.932c-0.4502-0.125-0.754-0.5449-0.732-1.0108c0.022-0.4668,0.3643-0.8554,0.8237-0.9375l12.7041-2.2588 l-7.3178-10.0361c-0.2779-0.3808-0.2515-0.9043,0.0625-1.2549c0.3139-0.3515,0.8315-0.4345,1.2407-0.2031l9.9941,5.6963 l-2.5083-15.8828c-0.0756-0.4805,0.2051-0.9463,0.6661-1.1035c0.4575-0.1543,0.9672,0.04,1.2002,0.4687l6.9072,12.6826 c0.2641,0.4854,0.0849,1.0928-0.3999,1.3565c-0.4868,0.2656-1.0928,0.0859-1.357-0.3994l-4.1381-7.5987l1.9296,12.2198 c0.0601,0.3798-0.103,0.7607-0.4194,0.9785c-0.3164,0.2187-0.7305,0.2344-1.0635,0.0469l-7.7519-4.419l5.5146,7.5635 c0.2032,0.2783,0.2486,0.6416,0.1197,0.9619c-0.1285,0.3203-0.4131,0.5508-0.7525,0.6113L15.241,35.181l10.8604,3.0107 c0.3511,0.0977,0.6211,0.378,0.7056,0.7325c0.0844,0.3535-0.0303,0.7256-0.2994,0.9707l-5.3349,4.8564l7.6128-2.873 c0.5156-0.1944,1.0937,0.0644,1.2885,0.582c0.1949,0.5176-0.0659,1.0938-0.5825,1.2891l-12.5093,4.7207 C16.8665,48.514,16.7474,48.5345,16.6297,48.5345z',
      fill: true,
      stroke: false,
    },
  ],
})

export const AvatarGameController = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M36.0455,53.8657l-10.4464,0 c-0.678,0-1.285,0.3865-1.6097,0.9818c-3.4584,6.3419-8.0837,7.8418-9.3408,8.0783c-0.1622,0.0305-0.3206,0.0576-0.4855,0.0624 C-0.2411,63.4131,7.0666,44.424,7.0666,44.424c2.0845-6.0901,7.1142-13.241,8.808-14.8908 c0.3487-0.3396,0.8102-0.5286,1.2969-0.5286h13.0964h11.4641h13.0964c0.4867,0,0.9483,0.189,1.2969,0.5286 c1.6938,1.6498,6.7235,8.8007,8.808,14.8908c0,0,7.3077,18.9891-7.0965,18.5642c-0.165-0.0049-0.3233-0.0319-0.4855-0.0624 c-1.2571-0.2365-5.8824-1.7364-9.3408-8.0783c-0.3246-0.5953-0.9316-0.9818-1.6097-0.9818l-10.4464,0',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'M24.0106 38.3755 L24.0106 39.1856 L19.7963 39.1856 L14.6472 39.1856 L14.6472 38.3755 L19.6921 38.3755z',
      fill: true,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M18.9239 34.0989 L19.7339 34.0989 L19.7339 38.3132 L19.7339 43.4622 L18.9239 43.4622 L18.9239 38.4174z',
      fill: true,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M26.25 46a4 4 0 1 0 8 0a4 4 0 1 0 -8 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M37.75 46a4 4 0 1 0 8 0a4 4 0 1 0 -8 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M46.6122 38.7806a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M55.0811 38.7806a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M50.8466 42.5357a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M50.8466 35.0667a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z',
      fill: true,
      stroke: false,
    },
    {
      path: 'M34.3553,25.0834V7.0572c0,0,0.5049-0.8693,1.2903-0.9914c0.4816-0.0748,1.0688,0.1313,1.7097,0.9914v18.0262',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarHeartEyes = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M13 36a23 23 0 1 0 46 0a23 23 0 1 0 -46 0Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M48.5859,42.6735c0,5.6296-4.1784,10.1046-12.5541,10.1046c-8.3738,0-12.6069-4.4888-12.6069-10.1047 C23.4249,42.6734,36.4503,45.7045,48.5859,42.6735z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M26.4992,27.4384c-1.2653-3.3541-6.441-3.5687-6.1168,1.3178c0.0431,0.6485,0.281,1.2724,0.6414,1.8135l5.3179,6.4224l0,0 l5.2212-6.266c0.5796-0.6964,0.9224-1.5779,0.905-2.4853c-0.0863-4.3523-5.0509-4.0351-6.1274-0.8036 z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M45.8012,27.4384c-1.2547-3.3541-6.3873-3.5687-6.0658,1.3178c0.0428,0.6485,0.2787,1.2724,0.6361,1.8135l5.2737,6.4224l0,0 l5.1777-6.266c0.5747-0.6964,0.9147-1.5779,0.8974-2.4853c-0.0856-4.3523-5.0089-4.0351-6.0763-0.8036 z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarLab = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'm42.06,16.9372v35.43c.1486,3.7465-2.7638,6.9062-6.51,7.0628-3.7462-.1565-6.6586-3.3163-6.51-7.0628V17.2855',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M28.150000000000002 15.2238a7.3933 3.137 0 1 0 14.7866 0a7.3933 3.137 0 1 0 -14.7866 0Z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'm42.06,29.84v23.08c.0022,3.5932-2.9088,6.5078-6.502,6.51h-.008c-.6006.0021-1.1985-.0816-1.7754-.2486-2.8026-.7909-4.7372-3.3493-4.7346-6.2614v-23.08',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'm29.277,30.8938c1.9619.9152,4.1087,1.3648,6.273,1.3137.9923.0058,1.9829-.0812,2.9589-.26.071-.0119.1539-.0236.2249-.0355,1.0725-.1919,2.1126-.5345,3.0891-1.0178',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
})

export const AvatarLeaf = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M29.63,27.91c8.1523-6.8285,20.7734-4.925,20.7734-4.925S49.804,35.8214,41.7789,42.44s-20.7734,4.9249-20.7734,4.9249S21.4778,34.738,29.63,27.91Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M54.0855,38.5427a10.2458,10.2458,0,0,1-1.58,4.7407,11.317,11.317,0,0,1-7.901,4.7406',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M58.8261,41.7031a10.2451,10.2451,0,0,1-1.58,4.7407,11.3173,11.3173,0,0,1-7.9011,4.7406',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M17.7406,30.6417a10.2455,10.2455,0,0,1,1.58-4.7407A11.3173,11.3173,0,0,1,27.2219,21.16',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M13,27.4813a10.2451,10.2451,0,0,1,1.58-4.7407A11.3173,11.3173,0,0,1,22.4813,18',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M18 50L20.901 47.024',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
})

export const AvatarMusicNote = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M51.6188 17.5516 L26.1735 23.2225 L26.105 18.5407 L51.5493 12.875z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M14.9695 51.5901a5.7868 5.7868 0 1 0 11.5736 0a5.7868 5.7868 0 1 0 -11.5736 0Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M26.105 18.5407L26.5431 51.5901',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M40.4195 46.0129a5.7868 5.7868 0 1 0 11.5736 0a5.7868 5.7868 0 1 0 -11.5736 0Z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M51.555 12.9635L51.9931 46.0129',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarRose = createStickerSVG({
  strokeWidth: 3.5,
  paths: [
    {
      path: 'M49.8675,30.3979c-0.4428,0.6348-1.2583,1.0208-2.0207,1.2533c-1.0107,0.3083-2.0878,0.3971-3.1319,0.2346 c-1.8682-0.2907-3.5402-1.174-4.8179-2.4517c-1.2014-1.2014-2.0541-2.7514-2.3933-4.4853',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M40.0032,22.8224c0-1.6312,1.6529-2.9535,3.6919-2.9535c2.039,0,3.6919,1.3223,3.6919,2.9535',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M49.4103,24.9866c0,1.1609-1.1763,2.1019-2.6274,2.1019c-0.7528,0-1.4609-0.3402-1.9982-0.8332 c-0.8327-0.7641-1.1063-2.0186-0.6344-3.0455c0.0686-0.1493,0.1516-0.284,0.252-0.3874',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M53.3083,15.9025c0.9791-0.6237,2.4048-0.1371,3.1844,1.0868c0.7796,1.2239,0.6178,2.7216-0.3613,3.3453',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M54.1952,35.9239c1.1689,2.1072,0.4082,4.7631-1.699,5.932c-2.1072,1.1689-4.7631,0.4082-5.932-1.699',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M38.1631,16.1932c-2.253-0.8548-5.9182,1.2312-6.5125,3.6757c-0.5693,2.3415,0.9006,6.2141,3.1536,7.0689',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M50.8669,20.8344c5.4159,0.6272,6.3961,6.4611,5.8024,8.7734c-0.8819,3.4349-5.3899,5.4013-8.1201,4.6907',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M50.8669,20.8344c1.2816-3.5081-0.5232-7.3909-4.0313-8.6725c-3.5081-1.2816-7.3909,0.5232-8.6725,4.0313',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M34.8042,26.9378c-2.0326,3.7956-0.6035,8.5203,3.1921,10.5529s8.5203,0.6035,10.5529-3.1921',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M25.9293,32.3094 c3.992,4.886,2.805,12.462,2.805,12.462s-7.66-0.347-11.653-5.233s-2.805-12.462-2.805-12.462S21.9373,27.4274,25.9293,32.3094z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M37.1043,40.8644 c-3.438,3.548-7.676,10.246-5.829,20.735',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
})

export const AvatarShaka = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M45.5271,36.5453 c5.8565,1.4749,9.2792-7.5763,0.8148-9.3306L31.5,24.3125c1.125-10.875,2-17.875-6.0625-19.3125c-2.4622-0.375-5.5,0-4.875,2.5 c3.25,14.625-3.125,22.6042-4.8966,24.4548c-7.1985,7.1985-7.1985,18.8695,0,26.068c3.1257,2.9355,6.1596,2.7272,13.7716,2.7272 c1.4375,0,20.6327,4.7314,20.6327,4.7314c6.875,1.8125,8.9705-5.5167,4.3455-7.0792l-4.3455-1.5669',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M44.703,45.5795 c5.8255,1.5323,8.0626-7.4024,0.8241-9.0342',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M43.4119,54.7786 c5.8275,1.5711,7.1882-7.5953,1.2911-9.1992',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      path: 'M43.4119 54.7786L37.719 53.1955',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M44.703 45.5795L39.6754 44.1473',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M45.5271 36.5453L41.3935 35.7015',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarUfo = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M52.04,41.4402c0,0.31-0.07,0.61-0.2,0.88 c-0.02,0.05-0.04,0.09-0.07,0.14c-0.35,0.61-1.02,1.03-1.77,1.03c-0.18,0-0.35-0.02-0.51-0.08c-0.53-0.13-0.99-0.48-1.25-0.95 c-0.19-0.3-0.29-0.65-0.29-1.02c0-0.55,0.22-1.06,0.6-1.42c0.24-0.27,0.57-0.46,0.94-0.55c0.16-0.05,0.33-0.07,0.51-0.07 C51.12,39.4002,52.04,40.3202,52.04,41.4402z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'M38.195,41.4402c0,0.31-0.07,0.61-0.2,0.88 c-0.02,0.05-0.04,0.09-0.07,0.14c-0.35,0.61-1.02,1.03-1.77,1.03c-0.18,0-0.35-0.02-0.51-0.08c-0.53-0.13-0.99-0.48-1.25-0.95 c-0.19-0.3-0.29-0.65-0.29-1.02c0-0.55,0.22-1.06,0.6-1.42c0.24-0.27,0.57-0.46,0.94-0.55c0.16-0.05,0.33-0.07,0.51-0.07 C37.275,39.4002,38.195,40.3202,38.195,41.4402z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'M24.445,41.4402c0,0.31-0.07,0.61-0.2,0.88 c-0.02,0.05-0.04,0.09-0.07,0.14c-0.35,0.61-1.02,1.03-1.77,1.03c-0.18,0-0.35-0.02-0.51-0.08c-0.53-0.13-0.99-0.48-1.25-0.95 c-0.19-0.3-0.29-0.65-0.29-1.02c0-0.55,0.22-1.06,0.6-1.42c0.24-0.27,0.57-0.46,0.94-0.55c0.16-0.05,0.33-0.07,0.51-0.07 C23.525,39.4002,24.445,40.3202,24.445,41.4402z',
      fill: false,
      stroke: true,
      strokeMiterlimit: 10,
    },
    {
      path: 'M61.66,46.07c-0.3,0.3-4.65,0.55-10.69,0.73c-1.62,0.04-3.36,0.08-5.17,0.12c-1.18,0.02-2.4,0.04-3.64,0.05 c-0.42,0-0.83,0.01-1.25,0.01c-0.12,0.01-0.23,0.01-0.35,0.01C39.91,47,39.26,47,38.6,47.01c-1.01,0.01-2.02,0.02-3.04,0.02 c-3.04,0.02-6.08,0.01-8.92-0.02c-1.15-0.01-2.27-0.03-3.34-0.04c-0.16-0.01-0.31-0.01-0.47-0.01c-0.51-0.01-1.01-0.02-1.5-0.03 c-5.98-0.15-10.32-0.42-10.76-0.86c-0.71-0.72-0.77-1.43-0.61-1.98c0.17-0.65,0.61-1.09,0.61-1.09l10.22-7.15h30.65L61.66,43 c0,0,0.29,0.59,0.4,1.28C62.17,44.88,62.14,45.59,61.66,46.07z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M42.16,46.97c-0.42,0.01-0.84,0.01-1.26,0.02c0.01,0,0.01-0.01,0.01-0.01C41.33,46.98,41.74,46.97,42.16,46.97z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M50.97,46.8c-1.63,3.04-7.43,5.3-14.38,5.39c-0.15,0.01-0.31,0.01-0.47,0.01c-0.87,0-1.73-0.03-2.56-0.1 c-0.88-0.07-1.73-0.17-2.55-0.31c-4.63-0.76-8.24-2.53-9.61-4.75c-0.03-0.04-0.05-0.07-0.07-0.11c0.49,0.01,0.99,0.02,1.5,0.03 c0.16,0,0.31,0,0.47,0.01c1.07,0.01,2.19,0.03,3.34,0.04c2.84,0.03,5.88,0.04,8.92,0.02c1.02,0,2.03-0.01,3.04-0.02 c0.66-0.01,1.31-0.01,1.96-0.02h0.34c0.42-0.01,0.84-0.01,1.26-0.02c1.24-0.01,2.46-0.03,3.64-0.05 C47.61,46.88,49.35,46.84,50.97,46.8z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M40.91,46.98c0,0,0,0.01-0.01,0.01h-0.34C40.68,46.99,40.79,46.99,40.91,46.98z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M42.16,46.97c-0.42,0.01-0.84,0.01-1.26,0.02h-0.34c0.12,0,0.23,0,0.35-0.01C41.33,46.98,41.74,46.97,42.16,46.97z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
    {
      path: 'M51.4,35.75v0.1H20.83v-0.09c0.19-2.67,1.07-5.16,2.46-7.28c2.3-3.5,5.98-6,10.27-6.72c0.83-0.14,1.69-0.21,2.56-0.21 c0.15,0,0.31,0,0.46,0.01C44.45,21.79,50.83,27.96,51.4,35.75z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})

export const AvatarZap = createStickerSVG({
  strokeWidth: 4,
  paths: [
    {
      path: 'M48.1628,4.4406L16.3224,37.7817c-0.6174,0.6465-0.1168,1.6589,0.8201,1.6589h19.0829l-18.304,28.8333l37.7269-36.4785 c0.659-0.6372,0.1665-1.6882-0.791-1.6882H36.3846L48.1628,4.4406z',
      fill: false,
      stroke: true,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,
    },
  ],
})
